
import fs from 'fs';
import Path from 'path';
import { configIntegration } from "../midelware/config-integrate.js"
import { createVueFile } from "../midelware/check-type.js"
import { initI18nConfig, integrateI18nToNuxtConfig } from '../midelware/i18n-config.js';
/**
  * init main structure for modules.
  * @param targetPath   - name of  main module .path for create module
  * @param moduleName   - name of module 
  * @param isPages      - if need pages, by default = true
  * @param isStore      - if need store, by default = false
  * @param isLayout      - if need layout, by default = false
  */
export const createModule = ({ targetPath, moduleName, isPages = true, isStore = false, isLayout = false, i18n = false }) => {
    // main module path
    const modulePath = Path.resolve(process.cwd(), targetPath, moduleName);
    // chack if module path is found
    if (!fs.existsSync(modulePath)) {
        // module path 
        fs.mkdirSync(modulePath, { recursive: true });
        // component path 
        const component = Path.resolve(process.cwd(), `${modulePath}/components`);
        // make dir for component 
        fs.mkdirSync(component, { recursive: true });
        // path for component dir to create component file
        const componentPath = Path.join(modulePath, `components/${moduleName}.vue`);
        // create component file
        createVueFile(componentPath, "component", `component`);
        // check if need page create dir for pages & create page
        // else create modules to make it as parent of modules
        if (isPages) {
            const pages = Path.resolve(process.cwd(), `${modulePath}/pages`);
            fs.mkdirSync(pages, { recursive: true });
            // path for page 
            const pagePath = Path.join(modulePath, `pages/${moduleName}.vue`);
            createVueFile(pagePath, "page", `${moduleName}`);
        } else {
            const pages = Path.resolve(process.cwd(), `${modulePath}/modules`);
            fs.mkdirSync(pages, { recursive: true });
        }
        if (i18n) {
            initI18nConfig();
            ///////////////////////////////////////
            const i18n = Path.resolve(process.cwd(), `${modulePath}/i18n`);
            fs.mkdirSync(i18n, { recursive: true });
            // path for page 
            const i18nEnPath = Path.join(modulePath, `i18n/en.ts`);
            createVueFile(i18nEnPath, "i18n", `en`);
            const i18nArPath = Path.join(modulePath, `i18n/ar.ts`);
            createVueFile(i18nArPath, "i18n", `ar`);
            integrateI18nToNuxtConfig()
        }
        // path for config file
        const configPath = Path.join(modulePath, 'nuxt.config.ts');
        createVueFile(configPath, "config", `nuxt.config.ts`);
        // // path for component 
        // ask for layout if init it
        if (isLayout) {
            const LayoutDir = Path.resolve(process.cwd(), `${modulePath}/layouts`);
            fs.mkdirSync(LayoutDir, { recursive: true });
            const layoutFile = Path.join(modulePath, `layouts/${moduleName}-lay.vue.vue`);
            createVueFile(layoutFile, "layout", `${moduleName}`);
        }
        // ask for store if init it
        if (isStore) {
            const storeDir = Path.resolve(process.cwd(), `${modulePath}/store`);
            fs.mkdirSync(storeDir, { recursive: true });
            const layoutFile = Path.join(modulePath, `store/${moduleName}Store.ts`);
            createVueFile(layoutFile, "store", `${moduleName}`);
        }
        configIntegration(targetPath, moduleName);

    } else {
        console.error(`Module "${moduleName}" already exists at: ${modulePath}`);
    }
} 